import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import { getSigV4HeadersForGet, getSigV4HeadersForPost } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import api from '@/utils/api';
import {
  PresentCampaignInfoRequest,
  PresentCampaignInfoResponse,
} from '@/types/api/mypage/campaign/presentCampaignInfo';
import {
  PresentCampaignAcceptRequest,
  PresentCampaignAcceptResponse,
} from '@/types/api/mypage/campaign/presentCampaignAccept';

/**
 * プレゼントキャンペーンAPI群をまとめたフック。
 * 情報取得と応募登録を同じ責務の下に集約し、画面側の呼び出しを単純化する。
 *
 * @returns execute 系API実行関数群
 */
const useApiPresentCampaign = () => {
  /**
   * プレゼントキャンペーン情報を取得する。
   * present_code がある場合だけクエリに付与して対象キャンペーンを絞り込む。
   */
  const executeGetPresentInfo = useCallback(
    async (
      request: PresentCampaignInfoRequest | null = null
    ): Promise<AxiosResponse<PresentCampaignInfoResponse>> => {
      const queryParams = new URLSearchParams();
      if (request?.present_code) {
        queryParams.append('code', request.present_code);
      }
      const apiUrl = `${ApiUrl.Read.PRESENT_CAMPAIGN_INFO}?${queryParams.toString()}`;
      const headers = await getSigV4HeadersForGet(apiUrl);
      return api.get(apiUrl, headers);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    []
  );

  /**
   * プレゼントキャンペーン応募を登録する。
   * 入力済み応募情報を送信し、応募完了可否を判定する。
   */
  const executePostPresentAccept = useCallback(
    async (
      request: PresentCampaignAcceptRequest
    ): Promise<AxiosResponse<PresentCampaignAcceptResponse>> => {
      const apiUrl = ApiUrl.Write.PRESENT_CAMPAIGN_ACCEPT;
      const headers = await getSigV4HeadersForPost(apiUrl, request);
      return api.post(apiUrl, request, headers);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    []
  );

  return { executeGetPresentInfo, executePostPresentAccept };
};

export default useApiPresentCampaign;
